// extracted by mini-css-extract-plugin
module.exports =  {"parts-container":"a10a3f92e9--parts-container--IETmH","sub-header":"a10a3f92e9--sub-header--Up_dR","part":"a10a3f92e9--part--KC7VR","item":"a10a3f92e9--item--M4kiF"};